import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-example-number-widget',
  templateUrl: './example-number-widget.component.html',
  styleUrls: ['./example-number-widget.component.scss']
})
export class ExampleNumberWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
